<script setup>
import { computed } from "vue";
import { Calendar } from "lucide-vue-next";
import SvgIcon from "@/shared/ui/svg-icon/SvgIcon.vue";

const props = defineProps({
  email: { type: String, default: null },
  dateOfBirth: { type: String, default: null },
  phone: { type: String, default: null },
});

const formattedDob = computed(() => {
  if (!props.dateOfBirth) return null;
  const d = new Date(props.dateOfBirth);
  if (Number.isNaN(d.getTime())) return props.dateOfBirth;
  return d.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
});
</script>

<template>
  <div class="flex flex-col gap-2 text-sm text-foreground">
    <a
      :href="`mailto:${email}`"
      class="group flex items-center gap-2.5 rounded-[var(--radius)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <SvgIcon
        name="sli-letter"
        class="h-4 w-4 shrink-0 text-muted-foreground group-hover:text-foreground transition-colors"
        aria-hidden="true"
        style="fill: none"
      />
      <div class="truncate group-hover:underline">
        {{ email ? email : $t("Не указано") }}
      </div>
    </a>
    <div v-if="formattedDob" class="flex items-center gap-2.5">
      <Calendar
        class="h-4 w-4 shrink-0 text-muted-foreground"
        aria-hidden="true"
        style="fill: none"
      />
      <div class="truncate">{{ formattedDob }}</div>
    </div>
    <a
      :href="`tel:${phone}`"
      class="group flex items-center gap-2.5 rounded-[var(--radius)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <SvgIcon
        name="sli-calls"
        class="h-4 w-4 shrink-0 text-muted-foreground group-hover:text-foreground transition-colors"
        aria-hidden="true"
        style="fill: none"
      />
      <div class="truncate group-hover:underline">
        {{ phone ? phone : $t("Не указано") }}
      </div>
    </a>
  </div>
</template>
